/**
 * Initializes the application and handles any errors that occur during initialization.
 * If an error occurs, it displays an error message in the user's language.
 * @aiAssisted - This code was written with the assistance of AI tools 🤖
 */
if (import.meta.env.DEV) {
    void import("react-grab").then(() => {
        (
            window as unknown as { __REACT_GRAB__?: { setOptions: (o: { maxContextLines?: number }) => void } }
        ).__REACT_GRAB__?.setOptions({ maxContextLines: 15 });
    });
}

import("./initialization")
    .then(({ initializeApplication }) => initializeApplication())
    .catch((error) => {
        console.error("Application initialization failed:", error);

        // Display the error message in the user's language
        const userLanguage = navigator.language.split("-")[0];
        const errorLanguages = ["de", "en", "es", "fr", "ja", "zh"];
        const targetLanguage = errorLanguages.includes(userLanguage) ? userLanguage : "en";
        const rootErrorContainer = document.getElementById(`root-error-container-${targetLanguage}`);
        if (rootErrorContainer) {
            rootErrorContainer.style.display = "grid";
        }
    });
